// Perfiles con acceso a la vista MPSP (Liverpool). El tipo de tabla depende del perfil.
export const PERFILES_MPSP_JEFES = [
  "Jefe_credito_liverpool",
  "Supervisor_credito_liverpool",
  "Jefe_credito_css_liverpool",
  "Supervisor_credito_css_liverpool",
];

export const PERFILES_MPSP_ASESORES = [
  "Asesor_tienda_liverpool",
  "Asesor_tienda_css_liverpool",
];

export const puedeVerMpsp = (clavePerfil) =>
  PERFILES_MPSP_JEFES.includes(clavePerfil) ||
  PERFILES_MPSP_ASESORES.includes(clavePerfil);
